import { Column, Row } from '~components/table-view-v3';
import MandateStatusBadge from '~direct-debits/components/client-signups/MandateStatusBadge';
import SendLinkButton from '~direct-debits/components/client-signups/SendLinkButton';
import { formatSentAt } from '~direct-debits/lib/formatSentAt';

import { GocardlessClientSignupRow } from '~direct-debits/models';

const formatOutstanding = (row: GocardlessClientSignupRow): string => {
  if (!row.has_outstanding_invoices) return 'No';
  return `Yes (${row.outstanding_invoice_count})`;
};

export const columns: Column[] = [
  {
    id: 'full_name',
    header: 'Client Name',
    type: 'text',
    sortable: true,
    deriveValue: (row) => row.full_name || `${row.first_name ?? ''} ${row.surname ?? ''}`.trim(),
  },
  {
    id: 'email',
    header: 'Email',
    type: 'text',
    deriveValue: (row) => row.email || '—',
  },
  {
    id: 'status',
    header: 'Mandate Status',
    type: 'custom',
    component: MandateStatusBadge,
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'outstanding',
    header: 'Outstanding Invoices',
    type: 'text',
    deriveValue: (row) => formatOutstanding(row as unknown as GocardlessClientSignupRow),
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'last_sent_at',
    header: 'Last Sent',
    type: 'text',
    deriveValue: (row) => formatSentAt(row.last_sent_at),
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: SendLinkButton,
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];

export const columnsFactory = (): Column[] => columns;

export type ClientSignupsRow = Row & GocardlessClientSignupRow;
